import {
  getUnitsLanguages,
  addUnitsLanguages,
  deleteUnitsLanguages,
  putUnitsLanguages,
  deleteUnitsLanguagesTranslation,
  getUnitsLanguagesLocales,
  getUnitsLanguagesProducts,
  downloadUnitsLanguages,
} from '../utils/requests/unitsLanguagesAPI'

export const LOAD_UNITS_LANGUAGES_LOCALE = 'LOAD_UNITS_LANGUAGES_LOCALE'
export const LOAD_UNITS_LANGUAGES_LOCALE_PENDING = 'LOAD_UNITS_LANGUAGES_LOCALE_PENDING'
export const LOAD_UNITS_LANGUAGES_LOCALE_FULFILLED = 'LOAD_UNITS_LANGUAGES_LOCALE_FULFILLED'
export const LOAD_UNITS_LANGUAGES_LOCALE_REJECTED = 'LOAD_UNITS_LANGUAGES_LOCALE_REJECTED'

export const LOAD_UNITS_LANGUAGES_PRODUCT_TYPES = 'LOAD_UNITS_LANGUAGES_PRODUCT_TYPES'
export const LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_PENDING = 'LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_PENDING'
export const LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_FULFILLED = 'LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_FULFILLED'
export const LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_REJECTED = 'LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_REJECTED'

export const LOAD_UNITS_LANGUAGES = 'LOAD_UNITS_LANGUAGES'
export const LOAD_UNITS_LANGUAGES_PENDING = 'LOAD_UNITS_LANGUAGES_PENDING'
export const LOAD_UNITS_LANGUAGES_FULFILLED = 'LOAD_UNITS_LANGUAGES_FULFILLED'
export const LOAD_UNITS_LANGUAGES_REJECTED = 'LOAD_UNITS_LANGUAGES_REJECTED'

export const LOAD_NEW_UNITS_LANGUAGES = 'LOAD_NEW_UNITS_LANGUAGES'
export const LOAD_NEW_UNITS_LANGUAGES_PENDING = 'LOAD_NEW_UNITS_LANGUAGES_PENDING'
export const LOAD_NEW_UNITS_LANGUAGES_FULFILLED = 'LOAD_NEW_UNITS_LANGUAGES_FULFILLED'
export const LOAD_NEW_UNITS_LANGUAGES_REJECTED = 'LOAD_NEW_UNITS_LANGUAGES_REJECTED'

export const POST_UNITS_LANGUAGES = 'POST_UNITS_LANGUAGES'
export const POST_UNITS_LANGUAGES_PENDING = 'POST_UNITS_LANGUAGES_PENDING'
export const POST_UNITS_LANGUAGES_FULFILLED = 'POST_UNITS_LANGUAGES_FULFILLED'
export const POST_UNITS_LANGUAGES_REJECTED = 'POST_UNITS_LANGUAGES_REJECTED'

export const PUT_UNITS_LANGUAGES = 'PUT_UNITS_LANGUAGES'
export const PUT_UNITS_LANGUAGES_PENDING = 'PUT_UNITS_LANGUAGES_PENDING'
export const PUT_UNITS_LANGUAGES_FULFILLED = 'PUT_UNITS_LANGUAGES_FULFILLED'
export const PUT_UNITS_LANGUAGES_REJECTED = 'PUT_UNITS_LANGUAGES_REJECTED'

export const DELETE_UNITS_LANGUAGES = 'DELETE_UNITS_LANGUAGES'
export const DELETE_UNITS_LANGUAGES_PENDING = 'DELETE_UNITS_LANGUAGES_PENDING'
export const DELETE_UNITS_LANGUAGES_FULFILLED = 'DELETE_UNITS_LANGUAGES_FULFILLED'
export const DELETE_UNITS_LANGUAGES_REJECTED = 'DELETE_UNITS_LANGUAGES_REJECTED'

export const DELETE_UNITS_LANGUAGES_TRANSLATION = 'DELETE_UNITS_LANGUAGES_TRANSLATION'
export const DELETE_UNITS_LANGUAGES_TRANSLATION_PENDING = 'DELETE_UNITS_LANGUAGES_TRANSLATION_PENDING'
export const DELETE_UNITS_LANGUAGES_TRANSLATION_FULFILLED = 'DELETE_UNITS_LANGUAGES_TRANSLATION_FULFILLED'
export const DELETE_UNITS_LANGUAGES_TRANSLATION_REJECTED = 'DELETE_UNITS_LANGUAGES_TRANSLATION_REJECTED'

export const DOWNLOAD_UNITS_LANGUAGES = 'DOWNLOAD_UNITS_LANGUAGES'
export const DOWNLOAD_UNITS_LANGUAGES_PENDING = 'DOWNLOAD_UNITS_LANGUAGES_PENDING'
export const DOWNLOAD_UNITS_LANGUAGES_FULFILLED = 'DOWNLOAD_UNITS_LANGUAGES_FULFILLED'
export const DOWNLOAD_UNITS_LANGUAGES_REJECTED = 'DOWNLOAD_UNITS_LANGUAGES_REJECTED'

export const CLEAR_UNITS_LANGUAGES_MESSAGES = 'CLEAR_UNITS_LANGUAGES_MESSAGES'

export function loadUnitsLanguagesLocales() {
  return {
    type: LOAD_UNITS_LANGUAGES_LOCALE,
    payload: getUnitsLanguagesLocales(),
  }
}

export function loadUnitsLanguagesProductTypes() {
  return {
    type: LOAD_UNITS_LANGUAGES_PRODUCT_TYPES,
    payload: getUnitsLanguagesProducts(),
  }
}

export function loadUnitsLanguages(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_UNITS_LANGUAGES : LOAD_UNITS_LANGUAGES,
    payload: getUnitsLanguages(queryParams),
  }
}

export function addUnitsLanguage(bodyParams) {
  return {
    type: POST_UNITS_LANGUAGES,
    payload: addUnitsLanguages(bodyParams),
  }
}

export function updateUnitsLanguage(id, bodyParams) {
  return {
    type: PUT_UNITS_LANGUAGES,
    payload: putUnitsLanguages(id, bodyParams),
  }
}

export function removeUnitsLanguageTranslation(id) {
  return {
    type: DELETE_UNITS_LANGUAGES_TRANSLATION,
    payload: deleteUnitsLanguagesTranslation(id),
    meta: { id },
  }
}

export function removeUnitsLanguage(id) {
  return {
    type: DELETE_UNITS_LANGUAGES,
    payload: deleteUnitsLanguages(id),
    meta: { id },
  }
}

export function downloadUnitLanguages(bodyParams) {
  return {
    type: DOWNLOAD_UNITS_LANGUAGES,
    payload: downloadUnitsLanguages(bodyParams),
  }
}

export function clearUnitsLanguagesMessages() {
  return {
    type: CLEAR_UNITS_LANGUAGES_MESSAGES,
  }
}
